import React from "react";
import * as PR from "../../prime-modules/index";
import "./BundleDetailsList.scss";
import Layout from "../../components/layout/Layout";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import getAssets from "../../assets/data/brandingAssets.json"
import RoamingPopup from "../../components/bundle/RoamingPopup";
import NetworksPopup from "../../components/bundle/NetworksPopup";
import AllowanceInfo from "../../components/bundle/AllowanceInfo";
import { Link, useNavigate, useParams } from "react-router-dom";
import { formatCurrency, snTransformData } from '../../utils/reuse';
import { getBundleDetail, getBundleslist } from '../../services/api';
import { useMutation } from "react-query";
import { useToast } from "../../context/ToastContext";
import { flag } from "country-emoji";
import { track } from "@plausible-analytics/tracker";

let { global_country } = getAssets.icons

const BundleDetailsList = () => {
    const { name: bundleName } = useParams();
    const location = useLocation();
    const iccid = location.state?.iccid ?? "";
    const [selectedBundle, setSelectedBundle] = useState({})
    const [allBundles, setAllBundles] = useState([])
    const filteredBundles = allBundles?.filter(
        bundle => bundle?.name !== selectedBundle?.name
    );
    const navigate = useNavigate(); 
    const { selectedCurrency } = useSelector(state => state.currency);
    const {labels} = useSelector(state=>state.language?.activelang);
    let { signal_icon } = getAssets.icons
    const [visible, setVisible] = useState(false);
    const [networkDialog, setNetworkDialog] = useState(null);
    const {showToast} = useToast()
    const [selectedCountry, setSelectedCountry] = useState("")
    const buyNowHandler = data => navigate('/payment', {state:{bundle:{...data,iccid: iccid?? ""}}});
    // const { roamingEnabled, countries, description, simtype, dataAmountForDisplay, duration, price, speed } = selectedBundle ?? {};


    let roamingEnabled, countries, description, simtype, dataAmountForDisplay, duration, prices, price, speed, priceCurrency, fup, allowances;

if (selectedBundle) {
  ({ roamingEnabled, countries, description, simtype, dataAmountForDisplay, duration, prices, price, speed, priceCurrency, fup, allowances } = selectedBundle);
}

const voiceAllowance = allowances?.find(a => a.type === "VOICE");
const smsAllowance = allowances?.find(a => a.type === "SMS");
const hasVoice = !!(voiceAllowance && (voiceAllowance.unlimited || voiceAllowance.amount > 0));
const hasSms = !!(smsAllowance && (smsAllowance.unlimited || smsAllowance.amount > 0));

    const handleDetailsClick = async (bundleData) => {       
        navigate(`/bundle-details/${encodeURIComponent(bundleData?.name)}` , {
            state: { iccid },
        });
        setSelectedBundle(bundleData)
    };
    const { mutate: getAllBundleApi } = useMutation(getBundleslist, {
        onSuccess: o => {
            const sortedBundles = o?.bundles?.sort((a,b) => (a.prices?.[selectedCurrency] || a.price) - (b.prices?.[selectedCurrency] || b.price))
            setAllBundles(sortedBundles)
        },
        onError: (o) => showToast("error",o?.message)
      });

    const { mutate: getBundleDetailsApi, isError, isLoading } = useMutation(getBundleDetail, {
        onSuccess: o => {
            const counrtyIso = o?.countries[0]?.country.iso;
            const countryName = o?.countries[0]?.country?.name;
            setSelectedCountry(counrtyIso)
            track("event-view-bundle-details", { props: { country: countryName }})
            const url  =`countries=${encodeURIComponent(counrtyIso)}&page=&limit=&direction=asc&orderBy=price&filter=&filterBy=&iccid=${iccid}`
            getAllBundleApi(url) 
            setSelectedBundle(o)
        },
        onError: (o) => showToast("error",o?.message)
      });

      useEffect(() => {
        if(bundleName) {
            getBundleDetailsApi(bundleName)
        }
    }, [bundleName, getBundleDetailsApi])

    return (
    <>
        <Layout>
            <div className="bundle-details">
                {isLoading ? ( 
                    <div className="loading">
                        <div className="custom-margin">
                            <i className="pi pi-spin pi-spinner"></i><br/>
                            <span>{labels?.LBLN0266}...</span>
                        </div>
                    </div>
            ) : isError ? ( 
                    <div className="loading">
                        <div className="custom-margin">
                            <span>{labels?.LBLN0131}</span>
                        </div>
                    </div> 
                ) :  Object.keys(selectedBundle || {}).length > 0 ? (
                    <>
                        <div className='grid'>
                            <div className="col-12 text-center">
                                <h1>{labels?.LBLN0016}</h1>
                            </div>
                            <div className="col-12 md:col-8 custom-width-7">
                                <div className="order-details-block">
                                    <div className='flex justify-content-between align-items-center details-header'>
                                        <div className="flex align-items-center gap-3">
                                            {isLoading ?<PR.Skeleton width="70px" height="70px" shape="circle" className="loading-skeleton"></PR.Skeleton> 
                                            : flag(selectedCountry)
                                                ? <div className="flag-icon">{flag(selectedCountry)}</div>
                                                : <PR.Image src={global_country} alt="country flag" className="flag-icon" />
                                            }
                                            <div>
                                                <h3>{description} {labels?.LBLN0255}</h3>
                                                <p>{simtype}, {dataAmountForDisplay}, {duration} Days, {countries?.map(c => c.country.name).join(", ")}</p>
                                            </div>
                                        </div>
                                        <h2 className="price">{formatCurrency(selectedCurrency || priceCurrency, prices?.[selectedCurrency] || price)}</h2>
                                    </div>
                                    <ul className="flex align-items-center justify-content-between">
                                        <li>{labels.LBLN0024}</li>
                                        <li>
                                            {dataAmountForDisplay}
                                            {dataAmountForDisplay?.toLowerCase() === "unlimited" && fup && (
                                                <span className="fup">FUP: {fup}</span>
                                            )}
                                        </li>
                                    </ul>
                                    {(hasVoice || hasSms) && (
                                        <ul className="flex align-items-center justify-content-between">
                                            <li>Allowances</li>
                                            <li>
                                                <AllowanceInfo 
                                                    allowances={allowances} 
                                                    dataAmountForDisplay={dataAmountForDisplay} 
                                                    fup={fup} 
                                                />
                                            </li>
                                        </ul>
                                    )}
                                    <ul className="flex align-items-center justify-content-between">
                                        <li>{labels.LBLN0025}</li>
                                        <li>{duration} {duration > 1 ? labels?.LBLN0254: labels?.LBLN0252}</li>
                                    </ul>
                                {speed?.length && <ul className="flex align-items-center justify-content-between">
                                        <li>{labels.LBLN0026}</li>
                                        <li>{speed?.join(", ")}</li>
                                    </ul>}
                                    <ul className="flex align-items-center justify-content-between">
                                        <li>{labels.LBLN0027}</li>
                                        <li>
                                            <span className="flex align-items-center">
                                                <LabelIcon id={labels?.LBLN0106} onClick={setVisible} geog_type={(roamingEnabled?.length === 0 || roamingEnabled?.length === 1)? "Local" : "Regional"} data={(roamingEnabled?.length === 0 || roamingEnabled?.length === 1)? countries : roamingEnabled} countShow={true} />
                                                {/* <div className="icon-blk ml-2">
                                                    <i className="pi pi-eye"></i>
                                                </div> */}
                                            </span>
                                        </li>
                                    </ul>
                                    <ul className="flex align-items-start justify-content-between border-none">
                                        <li>{labels?.LBLN0028}</li>
                                        <li className="networks">
                                            <span className="flex align-items-center">
                                            { (roamingEnabled?.length === 0 || roamingEnabled?.length === 1) 
                                            ? <LabelIcon id={labels?.LBLN0292} onClick={setNetworkDialog} data={countries?.[0]?.networks} countShow={true} />
                                            : <LabelIcon id={`${labels?.LBLN0029} ${labels?.LBLN0030}`} countShow={false} onClick={setNetworkDialog} data={(roamingEnabled?.length === 0 || roamingEnabled?.length === 1)? countries?.[0]?.networks : roamingEnabled} />}
                                            </span>
                                        </li>
                                    </ul>
                                    <PR.Button label={labels?.LBLN0032} onClick={() => buyNowHandler(selectedBundle)}  className="buy-button" />
                                </div>
                            </div>
                            <div className="col-12 md:col-4 custom-width-5">
                                <div className="order-details-block">
                                    <div className="details-header">
                                        <h3>{labels?.LBLN0328 || "Other Bundles"}</h3>
                                        <div className="line"></div>
                                    </div>
                                    <div className="fixed-height">
                                        {filteredBundles.map((bundle, index) => (
                                            <div key={index} className={`bundle-box ${index === 0 ? 'highlight-popular' : ''}`}>
                                                <div className='flex gap-2 justify-content-end relative'>
                                                    <PR.Image src={signal_icon} alt="country flag" className="icon" />
                                                    <h4>{bundle?.dataAmountForDisplay}</h4>
                                                </div>
                                                <div className="flex align-items-center gap-3">
                                                    {isLoading ?<PR.Skeleton width="60px" height="60px" shape="circle" className="loading-skeleton"></PR.Skeleton> 
                                                        : flag(selectedCountry)
                                                        ? <div className="flag-icon">{flag(selectedCountry)}</div>
                                                        : <PR.Image src={global_country} alt="country flag" className="flag-icon" />
                                                    } <div>
                                                        <h3>{bundle?.duration} {labels?.LBLN0254} {labels?.LBLN0255}</h3>
                                                        <Link onClick={e => { e.preventDefault(); handleDetailsClick(bundle); }}>{labels?.LBLN0111}</Link>
                                                    </div>
                                                </div>
                                                <div className='flex justify-content-between align-items-center mt-3'>
                                                    <h2>{formatCurrency(selectedCurrency || bundle?.priceCurrency, bundle?.prices?.[selectedCurrency] || bundle?.price)}</h2>
                                                    <PR.Button label={labels?.LBLN0032} onClick={() => buyNowHandler(bundle)} className="buy-button" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                    </div>
                    <RoamingPopup labels={labels} setVisible={setVisible} visible={visible} roamingEnabled={roamingEnabled} />
                    <NetworksPopup labels={labels} setVisible={setVisible} networkDialog={networkDialog} roamingEnabled={roamingEnabled} countries={countries} setNetworkDialog={setNetworkDialog} />
                    </>           
                ) : null }
            </div>
        </Layout>
    </>
  );
};

export default BundleDetailsList;

export const LabelIcon = ({ onClick, data, id, countShow, geog_type }) => {
  if (!data || data.length === 0) return "N/A";

  const displayText = data.length === 1
    ? geog_type === "Local"
      ? data[0]?.country?.name?.split("(")[0] 
      : snTransformData(data)[0]
    : `${countShow ? data.length : ''} ${id}`;

  return (
    <>
      {displayText}
      {data.length > 1 && (
        <div className="icon-blk ml-2 cursor-pointer" onClick={onClick}>
          <i className="pi pi-eye"></i>
        </div>
      )}
    </>
  );
};
